<!-- Page Header -->
<div class="page-header" *ngIf="!embutido">
  <div class="header-icon">
    <i class="pi pi-th-large"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- TabView: Cadastro e Lista -->
<div class="tabs-container" [class.embutido]="embutido">
  <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">

    <!-- Aba 1: Cadastro -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-plus-circle tab-icon"></i>
        <span>{{ texts.aba_cadastro }}</span>
      </ng-template>

      <div class="form-card">
        <div class="card-header">
          <div class="card-header-icon">
            <i class="pi pi-plus-circle"></i>
          </div>
          <span class="card-header-title">{{ texts.selecionar_unidade }}</span>
        </div>
        <div class="card-content">
          <div class="form-grid">
            <div class="form-field full">
              <label class="form-label">{{ texts.selecionar_unidade }} <span class="required">*</span></label>
              <p-dropdown [options]="unidadeDeMedidaDisponiveis" [(ngModel)]="form.id" optionLabel="nome"
                optionValue="id" [placeholder]="placeholders.selecione_unidade"
                [filter]="true" filterBy="nome" [showClear]="true" appendTo="body"
                styleClass="w-full">
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>

      <!-- Botoes de Acao -->
      <div class="actions-container">
        <button pButton [label]="botoes.adicionar" icon="pi pi-check"
          (click)="submit()" class="btn-primary">
        </button>
      </div>
    </p-tabPanel>

    <!-- Aba 2: Lista -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-list tab-icon"></i>
        <span>{{ texts.aba_lista }}</span>
      </ng-template>

      <div class="table-card">
        <div class="card-header">
          <div class="card-header-icon table-icon">
            <i class="pi pi-list"></i>
          </div>
          <span class="card-header-title">{{ texts.lista_unidades }}</span>
          <div class="card-header-actions">
            <button pButton [label]="botoes.nova_unidade" icon="pi pi-plus"
              (click)="novaUnidade()" class="btn-primary btn-sm"></button>
          </div>
        </div>
        <div class="card-content">
          <!-- Barra de busca + Seletor de colunas -->
          <div class="search-bar">
            <p-iconField iconPosition="right" class="search-field">
              <p-inputIcon styleClass="pi pi-search" />
              <input pInputText type="text"
                [placeholder]="placeholders.buscar"
                [(ngModel)]="filterName"
                (ngModelChange)="onSearchChange($event)" />
            </p-iconField>

            <app-column-selector
              [columns]="columns"
              [storageKey]="STORAGE_KEY"
              (columnsChange)="onColumnsChange($event)">
            </app-column-selector>
          </div>

          <!-- Tabela -->
          <p-table [value]="unidadeDeMedidaEmpresa" [loading]="loading"
            (sortFunction)="customSort($event)" [customSort]="true"
            [tableStyle]="{ 'width': '100%' }">

            <ng-template pTemplate="header">
              <tr>
                <th [hidden]="!isColumnVisible('codigoDTE')" pSortableColumn="unidadeMedidaDeItemEmpresa.codigoDTE">{{ labels.codigo_dte }}<p-sortIcon field="unidadeMedidaDeItemEmpresa.codigoDTE" /></th>
                <th [hidden]="!isColumnVisible('tipoUnidade')" pSortableColumn="unidadeMedidaDeItemEmpresa.tipoUnidade">{{ labels.tipo_de_unidade }}<p-sortIcon field="unidadeMedidaDeItemEmpresa.tipoUnidade" /></th>
                <th [hidden]="!isColumnVisible('nome')" pSortableColumn="unidadeMedidaDeItemEmpresa.nome">{{ labels.nome }}<p-sortIcon field="unidadeMedidaDeItemEmpresa.nome" /></th>
                <th [hidden]="!isColumnVisible('casasDecimais')" pSortableColumn="unidadeMedidaDeItemEmpresa.casasDecimais">{{ labels.casas_decimais }}<p-sortIcon field="unidadeMedidaDeItemEmpresa.casasDecimais" /></th>
                <th [hidden]="!isColumnVisible('criadoEm')" pSortableColumn="criadoEm">{{ labels.data_inclusao }}<p-sortIcon field="criadoEm" /></th>
                <th [hidden]="!isColumnVisible('acoes')" style="width: 6rem">{{ labels.acoes }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-product>
              <tr>
                <td [hidden]="!isColumnVisible('codigoDTE')">{{ product.unidadeMedidaDeItemEmpresa.codigoDTE }}</td>
                <td [hidden]="!isColumnVisible('tipoUnidade')">{{ product.unidadeMedidaDeItemEmpresa.tipoUnidade }}</td>
                <td [hidden]="!isColumnVisible('nome')">{{ product.unidadeMedidaDeItemEmpresa.nome }}</td>
                <td [hidden]="!isColumnVisible('casasDecimais')">{{ product.unidadeMedidaDeItemEmpresa.casasDecimais }}</td>
                <td [hidden]="!isColumnVisible('criadoEm')">{{ formatarDataEHora(product.criadoEm) }}</td>
                <td [hidden]="!isColumnVisible('acoes')" class="actions">
                  <button *ngIf="!embutido" pButton icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-sm p-button-danger"
                    [pTooltip]="tooltips.excluir" tooltipPosition="top"
                    (click)="deletarUnidadeMedida(product.id)">
                  </button>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex flex-column align-items-center">
                    <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                    <div class="text-gray-500 text-lg">{{ texts.nenhuma_unidade }}</div>
                    <div class="text-gray-400 text-sm mt-1">{{ texts.ajuste_filtros }}</div>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="loadingbody">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex justify-content-center align-items-center">
                    <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                    <span class="ml-3">{{ texts.carregando }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!-- Paginacao -->
          <div class="pagination-container">
            <div>
              <p-paginator (onPageChange)="onPageChange3($event)"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                [first]="first3" [rows]="rows3"
                [totalRecords]="totalRecords"
                [showFirstLastIcon]="true">
              </p-paginator>
            </div>
            <div class="flex align-items-center">
              <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
              <p-dropdown [options]="pageSizeOptions" optionLabel="label"
                optionValue="value" [(ngModel)]="rows3"
                (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>

  </p-tabView>
</div>

<p-toast></p-toast>

<!-- Modal de Confirmacao de Exclusao (Wave Design) -->
<p-dialog [(visible)]="deleteDialogVisible" [showHeader]="false" [modal]="true"
  [closable]="false" [draggable]="false" styleClass="dialog-wave-redesign" [style]="{ width: '30rem' }">
  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-trash" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmacao }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ texts.confirmar_exclusao }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar" class="p-button-secondary" (click)="deleteDialogVisible = false"></button>
    <button pButton [label]="botoes.confirmar" severity="danger" icon="pi pi-trash" (click)="confirmarExclusao()"></button>
  </ng-template>
</p-dialog>
